import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from './variantsActions';
import VariantDetailsContainer from './VariantDetails/VarianDetailsContainer';
import VariantListContainer from './VariantList/VariantListContainer';
import { LoadingBlueLarge } from 'merchant-portal-components';

const VariantsContainer = ({
  componentType,
  variantToEdit,
  getVariants,
  requestParams,
  updateVariantsRequestParams,
}) => {
  const [searchString, setSearchString] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  useEffect(() => {
    return () => {
      updateVariantsRequestParams({
        ...requestParams,
        page_number: 1,
      });
      setSearchString('');
    };
  }, []);
  useEffect(() => {
    setIsSearching(true);
    const debounce = setTimeout(() => {
      const newRequestParams = {
        ...requestParams,
        page_number: 1,
        search_string: searchString,
      };
      if (searchString.length > 2 || searchString === '') {
        getVariants(newRequestParams);
      }
      updateVariantsRequestParams(newRequestParams);
      setIsSearching(false);
    }, 1500);
    return () => {
      clearTimeout(debounce);
    };
  }, [searchString, componentType]);
  return (
    <div>
      {componentType === 'list' ? (
        <VariantListContainer
          searchString={searchString}
          setSearchString={setSearchString}
          isSearching={isSearching}
        />
      ) : componentType === 'create' ? (
        <VariantDetailsContainer></VariantDetailsContainer>
      ) : (
        <VariantDetailsContainer
          variantToEdit={variantToEdit}
        ></VariantDetailsContainer>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  componentType: state.variantsReducer.componentType,
  requestParams: state.variantsReducer.requestParams,
  variantToEdit: state.variantsReducer.variantToEdit,
  isVariantAvailable: state.variantsReducer.isVariantAvailable,
});
export default connect(mapStateToProps, actions)(VariantsContainer);
